import React from 'react';
import { Skeleton } from '@mui/material';
import _ from 'lodash';
import useChannelVirtualSuperHeat, {
  ChannelVirtualSuperHeatProps,
} from './hooks/useChannelVirtualSuperHeat';
import { ChannelDetail } from './ChanelPanel';
import { getPreferredUnit } from '../../../../../redux/controlUnit/api/util/sensor/formatValues';
import usePreferredTemperatureUnit from '../../../../../redux/settings/hooks/usePreferredTemperatureUnit';
import { DEFAULT_VALUE_SENSOR } from '../../../../../redux/controlUnit/api/util/constants';

function ChannelVirtualSuperHeat(props: ChannelVirtualSuperHeatProps) {
  const {
    name,
    loading,
    value: superHeatValue,
    unitString: superHeatUnitValue,
  } = useChannelVirtualSuperHeat(props);
  const { data: preferredTemperatureUnit } = usePreferredTemperatureUnit();
  const unit = getPreferredUnit(superHeatUnitValue, preferredTemperatureUnit);
  const fixedValue = `${
    isNaN(superHeatValue as unknown as number)
      ? DEFAULT_VALUE_SENSOR
      : Number(superHeatValue).toFixed(0)
  }`;
  return (
    <>
      {loading ? (
        <Skeleton variant="text" width={'100%'} component={'span'} />
      ) : (
        <ChannelDetail title={name ?? ''} value={fixedValue} unit={`${unit}`} />
      )}
    </>
  );
}

export default ChannelVirtualSuperHeat;
